'use client';

import EcoIconPlay from 'eco-design-micro/icons/eco-icon-play';
import { BtnSingProps } from 'eco-design-micro/props/btn/BtnSingProps';
import { DataLayerProps } from 'eco-design-micro/props/DataLayerProps';
import gtm from 'eco-design-reliance/gtm';
import EcoButton from 'eco-design/base/eco-button';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';
import { useState } from 'react';
interface BannerBtnProps extends BtnSingProps {
    prefixCls: string;
    isYouToBe?: boolean;
    gtm_title?: React.ReactNode;
    dataLayer?: DataLayerProps;
    className?: string;
    dataBtnId?: string;
}
export default function BannerBtn({
    prefixCls,
    lTheme,
    lType,
    lHref,
    children,
    lFontColor,
    lBgColor,
    isYouToBe,
    gtm_title,
    dataLayer,
    className,
    dataBtnId,
}: BannerBtnProps) {
    const [isOpen, setIsOpen] = useState(false);
    if (!lHref) {
        return null;
    }
    const gtm_title2 = (gtm_title as string) || '';
    const gtm_position = 'Product Detail_1';
    // youtube 视频
    const dataLayer_youtube = {
        event: 'uaEvent',
        event_name: 'video',
        title_name: gtm_title2,
        position: gtm_position,
    };
    // 去 shopify 详情页
    const dataLayer_buy = {
        event: 'uaEvent',
        event_name: 'buy',
        product_name: gtm_title2,
        position: gtm_position,
    };
    // 去结帐页
    const dataLayer_checkout = {
        event: 'uaEvent',
        event_name: 'checkout',
        button_name: `${children}_${gtm_title2}`,
    };
    // 打开其它弹窗
    const dataLayer_win_other = {
        event: 'uaEvent',
        event_name: 'select_banner',
        banner_name: gtm_title2,
        position: gtm_position,
        button_name: children,
    };
    // 打开弹窗
    const openHandle = () => {
        let dataLayer_send1 = null;
        if (isYouToBe) {
            setIsOpen(true);
            dataLayer_send1 = dataLayer_youtube;
        } else if (lHref.includes('/products/')) {
            dataLayer_send1 = dataLayer_buy;
        } else if (lHref.includes('/checkout/')) {
            dataLayer_send1 = dataLayer_checkout;
        } else {
            dataLayer_send1 = dataLayer_win_other;
        }
        const dataLayer_send = dataLayer ? dataLayer : dataLayer_send1; //优先使用外部传入的埋点
        try {
            gtm.push(dataLayer_send);
        } catch (error) {
            /* empty */
        }
    };
    // 关闭弹窗
    const hideHandle = () => {
        setIsOpen(false);
    };

    return (
        <>
            <EcoButton
                lTheme={lTheme}
                lHref={isYouToBe ? undefined : lHref}
                lType={lType}
                lBgColor={lBgColor}
                lFontColor={lFontColor}
                onClick={openHandle}
                className={`${prefixCls}-btn-youtube ${className}`}
                lRadius="ellipse"
                data-btn-id={dataBtnId}
            >
                {children}
                {isYouToBe && <EcoIconPlay />}
            </EcoButton>
            {isOpen && lHref && <EcoDialogVideo open={isOpen} src={lHref} callback={hideHandle} />}
        </>
    );
}
